import { render, staticRenderFns } from "./approvalList.vue?vue&type=template&id=396005ba&scoped=true&"
import script from "./approvalList.vue?vue&type=script&lang=ts&"
export * from "./approvalList.vue?vue&type=script&lang=ts&"
import style0 from "./approvalList.vue?vue&type=style&index=0&id=396005ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396005ba",
  null
  
)

export default component.exports